import { render, staticRenderFns } from "./user_settings.vue?vue&type=template&id=4e859592&scoped=true&lang=html&"
import script from "./user_settings.vue?vue&type=script&lang=js&"
export * from "./user_settings.vue?vue&type=script&lang=js&"
import style0 from "./user_settings.vue?vue&type=style&index=0&id=4e859592&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e859592",
  null
  
)

export default component.exports